import { Button } from "@/components/ui/Button";
import { useDeleteConnection } from "../hooks";
import { apiErr } from "../utils";

/** Potwierdzenie „Usuń" z nagłówka karty projektu ZE (dyrektor / CEO). Usunięcie jest
 *  miękkie: profil znika z portfela i karty, a kamienie, działki, sprawy i pliki
 *  zostają w bazie — administrator może go przywrócić. */
export function DeleteConnectionDialog({
  connectionId,
  projectName,
  onClose,
  onDeleted,
}: {
  connectionId: string;
  projectName: string;
  onClose: () => void;
  onDeleted: () => void;
}) {
  const del = useDeleteConnection();
  const submit = () => del.mutate(connectionId, { onSuccess: onDeleted });

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-connection-title"
        className="card w-full max-w-md shadow-hard-red"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-4 py-2.5 border-b border-[var(--color-border)] bg-[var(--color-bg-elevated)]">
          <h3
            id="delete-connection-title"
            className="font-mono text-xs font-bold uppercase tracking-widest text-[var(--color-text-primary)]"
          >
            Usuń projekt ZE
          </h3>
        </div>
        <div className="p-4 space-y-3">
          <p className="text-sm text-[var(--color-text-secondary)]">
            Czy na pewno usunąć projekt przyłączeniowy{" "}
            <span className="font-semibold text-[var(--color-text-primary)]">{projectName}</span>?
          </p>
          <p className="text-sm text-[var(--color-text-secondary)]">
            Projekt zniknie z listy projektów ZE. Kamienie, działki, sprawy i pliki zostają
            w systemie — administrator może go przywrócić. Samo przedsięwzięcie pozostaje bez zmian.
          </p>
          {del.isError && (
            <p className="text-xs text-[var(--color-primary)] font-mono">{apiErr(del.error)}</p>
          )}
          <div className="flex justify-end gap-2 pt-1">
            <Button variant="ghost" size="sm" onClick={onClose}>Anuluj</Button>
            <Button variant="danger" size="sm" loading={del.isPending} onClick={submit}>
              Usuń
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
